export default __webpack_public_path__ + "static/media/arrow-right.b93ab5e8.svg";